import { Component, type ReactNode } from "react";
import { ar } from "@/i18n/ar";
import { logError } from "@/lib/log";
import { Notice } from "@/components/Notice";
import { Button } from "@/components/Button";

export class ErrorBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  override state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  override componentDidCatch(error: unknown) {
    logError("render_error", error);
  }

  override render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div className="flex h-full flex-col items-center justify-center gap-3 p-6">
        <Notice kind="error" text={ar.shell.crashed} />
        <Button onClick={() => window.location.reload()}>{ar.shell.reload}</Button>
      </div>
    );
  }
}
